let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3wOzk")).then(() => parcelRequire('1O1kw'));